module.exports = __webpack_public_path__ + "img/sav_avatar.0376c1d0.jpeg";